import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, QUIZ_ALL, QUIZ_BY_ID, QUIZ_CACHE_ALL, QUIZ_LIST, QUIZ_TYPES } from '../constants/actionTypes'

const selector = (state: RootState) => prop(GLOBAL_STATE, state)

export const quizByIdSelector = createSelector(selector, data => data[QUIZ_BY_ID])

export const quizAllSelector = createSelector(selector, data => data[QUIZ_ALL])

export const quizCacheAllSelector = createSelector(selector, data => data[QUIZ_CACHE_ALL])

export const quizListSelector = createSelector(selector, data => data[QUIZ_LIST])

// export const quizResultsSelector = createSelector(selector, data => data[QUIZ_RESULTS])

// export const quizResultOpenSelector = createSelector(selector, data => data[QUIZ_RESULT_OPEN])

export const quizTypesSelector = createSelector(selector, data => data[QUIZ_TYPES])
